import React, { useEffect, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { Breadcrumb, Collapse, Form, Table } from "react-bootstrap";
import UseToggle from "../../../Hooks/UseToggle";
import { FaFile, FaFolder } from "react-icons/fa";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import AddNewFolder from "./AddNewFolder";
import UpdateFolder from "./UpdateFolder";
import CopyFolder from "./CopyFolder";
import MoveFolder from "./MoveFolder";
import DuplicateFolder from "./DuplicateFolder";
import Swal from "sweetalert2";
import { BsFillFolderFill, BsImage } from "react-icons/bs";
import { AiOutlineFilePdf } from "react-icons/ai";
import { GoFileZip } from "react-icons/go";
import { GrDocumentCsv, GrDocumentExcel, GrDocumentPpt, GrDocumentRtf, GrDocumentTxt, GrDocumentWord } from "react-icons/gr";
import GenerateZipFile from "./GenerateZipFile";
import ExtractedZipFile from "./ExtractedZipFile";
import UploadMultiFilesFolders from "./UploadMultiFilesFolders";
import FilePreview from "./FilePreview";
import SplitPane from "react-split-pane";
import { IoFolder } from "react-icons/io5";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const FileManagement = ({
  tableRef,
  onMouseDown,
  ids,
  handleAddNewTab,
  setFileFolderUpdater,
  fileFolderUpdater
}) => {
  const toggles = UseToggle();
  const { studyId } = useParams()
  const [loader, setLoader] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [viewType, setViewType] = useState("grid");
  const [breadcrumb, setBreadcrumb] = useState(false);
  const [breadcrumbData, setBreadcrumbData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [fileManager, setFileManager] = useState([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const AppsRef = useRef(null);
  const gridRef = useRef(null);
  const tableDRef = useRef(null);
  const addRef = useRef(null);
  const updateRef = useRef(null);
  const copyRef = useRef(null);
  const moveRef = useRef(null);
  const duplicateRef = useRef(null);
  const uploadRef = useRef(null);
  const generateZipRef = useRef(null);
  const extractZipRef = useRef(null);
  const fileURLRef = useRef(null);
  const getS3EditorFolders = async (path) => {
    setLoader(true);
    if (!path) {
      setBreadcrumbData([])
    }
    setSelectedItems([])
    let data = await editorS3FileManagerServices.getS3EditorFolders(studyId, "root", searchData, path, "both");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getS3EditorFolders(ids?.fullPath || "");
  }, [searchData, ids?.fullPath, fileFolderUpdater]);

  const isSelected = (fullPath) =>
    selectedItems.some((item) => item.fullPath === fullPath);

  const handleItemClick = (e, item, index) => {
    const { fullPath, url, name, uniqueKey } = item;
    if (e.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index);
      const end = Math.max(lastSelectedIndex, index);
      const rangeItems = fileManager.slice(start, end + 1).map((f) => ({
        fullPath: f.fullPath,
        uniqueKey: f.uniqueKey,
        url: f.url,
      }));

      setSelectedItems(rangeItems);
    } else {
      setSelectedItems([{ fullPath, url, name, uniqueKey }]);
      setLastSelectedIndex(index);
    }
  };

  const handleCheckboxChange = (item, index) => {
    const { fullPath, url, name, uniqueKey } = item;
    setLastSelectedIndex(index);

    setSelectedItems((prev) => {
      const exists = prev.some((x) => x.fullPath === fullPath);
      if (exists) {
        return prev.filter((x) => x.fullPath !== fullPath);
      } else {
        return [...prev, { fullPath, url, name, uniqueKey }];
      }
    });
  };

  const softDeleteS3EditorFolder = async (path) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete this folder!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Delete it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.path = path;
        userData.type = "delete";
        userData.studyId = studyId;
        let data =
          await editorS3FileManagerServices.softDeleteS3EditorFolder(
            userData
          );
        if (data?.statusCode === 200) {
          setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000))
        }
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideToolbar = AppsRef.current?.contains(event.target);
      const clickedInsideGrid = gridRef.current?.contains(event.target);
      const clickedInsideTable = tableRef.current?.contains(event.target);
      const clickedInsideAdd = addRef.current?.contains(event.target);
      const clickedInsideUpdate = updateRef.current?.contains(event.target);
      const clickedInsideCopy = copyRef.current?.contains(event.target);
      const clickedInsideMove = moveRef.current?.contains(event.target);
      const clickedInsideDuplicate = duplicateRef.current?.contains(event.target);
      const clickedInsideUpload = uploadRef.current?.contains(event.target);
      const clickedInsideGenerateZip = generateZipRef.current?.contains(event.target);
      const clickedInsideExtractZip = extractZipRef.current?.contains(event.target);
      const clickedInsideFileURL = fileURLRef.current?.contains(event.target);
      const clickedInMenu =
        event.target.closest(".node-menu") || event.target.closest(".kebab-icon");
      if (
        !clickedInsideToolbar &&
        !clickedInsideGrid &&
        !clickedInsideTable &&
        !clickedInsideAdd &&
        !clickedInsideUpdate &&
        !clickedInsideCopy &&
        !clickedInsideMove &&
        !clickedInsideDuplicate &&
        !clickedInsideUpload &&
        !clickedInsideGenerateZip &&
        !clickedInsideExtractZip &&
        !clickedInsideFileURL &&
        !clickedInMenu
      ) {
        setSelectedItems([]);
        setFileURL("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  useEffect(() => {
    if (ids?.fullPath) {
      let path = ids?.fullPath?.split("/").filter(Boolean);
      setBreadcrumbData(path);
    }
  }, [ids]);

  const areAllPathsFiles = (selectedItems = []) => {
    return selectedItems.every(item => /\.[^/]+$/.test(item.fullPath));
  }

  function getPathOnClick(clicked) {
    const index = breadcrumbData.indexOf(clicked);
    if (index === -1) return "";
    let result = breadcrumbData.slice(0, index + 1).join("/") + "/";
    setBreadcrumbData(breadcrumbData.slice(0, index + 1))
    handleAddNewTab(`File Management`,
      "fa-solid fa-desktop",
      `fileManagement`,
      { ...ids, name: clicked, fullPath: result }
    )
    getS3EditorFolders(result)
  }

  const isFile = (key) => {
    if (key) {
      const lastPart = key.split("/").filter(Boolean).pop() || "";
      const ext = lastPart.includes(".") ? lastPart.split(".").pop() : "";
      return ext;
    }
  };

  const downloadDocumentFile = async (selectedItems) => {
    if (selectedItems.length === 1) {
      const anchor = document.createElement("a");
      anchor.href = selectedItems?.[0]?.url;
      anchor.rel = "noopener noreferrer";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      return;
    } else {
      const zip = new JSZip();
      for (const item of selectedItems) {
        const response = await fetch(item?.url);
        if (!response.ok) {
          continue;
        }
        const blob = await response.blob();
        zip.file(item?.name, blob);
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${ids?.name}.zip`);
    }
  };

  return (
    <>
      <div
        ref={AppsRef}
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 34 }}
      >
        <div
          className="hstack gap-1">
          {(selectedItems?.length === 0 || (selectedItems?.length === 1 && !isFile(selectedItems?.[0]?.fullPath))) && (ids?.uniqueKey !== "Standard" && !selectedItems.some(item => item.uniqueKey === "Standard")) &&
            <>
              <i
                title="Add New Folder"
                className="fa-solid fa-plus-square CP"
                onClick={() => toggles.setToggle()}
              />
              <div className="vr"></div>
              <i
                title="Upload File or Folder"
                className="fa-solid fa-cloud-arrow-up CP"
                onClick={() => toggles.setToggle5()}
              />
              <div className="vr"></div>
            </>
          }
          {selectedItems?.length > 0 && (
            <>
              {selectedItems?.length === 1 && (
                <>
                  {(ids?.uniqueKey !== "Standard" && !selectedItems.some(item => item.uniqueKey === "Standard")) &&
                    <>
                      <i
                        title="Rename"
                        className="fa-solid fa-edit CP"
                        onClick={() => toggles.setToggle1()}
                      />
                      <div className="vr"></div>
                    </>
                  }
                  <i
                    title="Duplicate"
                    className="fa-solid fa-clone CP"
                    onClick={() => toggles.setToggle4()}
                  />
                  <div className="vr"></div>
                  {isFile(selectedItems?.[0]?.fullPath) === "zip" &&
                    <>
                      <i
                        title="Extract Zip"
                        className="fa-regular fa-file-zipper CP"
                        onClick={() => toggles.setToggle7()}
                      />
                      <div className="vr"></div>
                    </>
                  }
                </>
              )}
              {selectedItems?.length > 0 && (
                <>
                  {(ids?.uniqueKey !== "Standard" && !selectedItems.some(item => item.uniqueKey === "Standard")) &&
                    <>
                      <i
                        title="Cut"
                        className="fa-solid fa-cut CP"
                        onClick={() => toggles.setToggle3()}
                      />
                      <div className="vr"></div>
                      <i
                        title="Copy in Other Folder"
                        className="fa-solid fa-copy CP"
                        onClick={() => toggles.setToggle2()}
                      />
                      <div className="vr"></div>
                    </>
                  }
                  <i
                    title="Generate Zip File"
                    className="fa-solid fa-file-zipper CP"
                    onClick={() => toggles.setToggle6()}
                  />
                  <div className="vr"></div>
                  {((ids?.uniqueKey !== "Standard" && !selectedItems.some(item => item.uniqueKey === "Standard")) || areAllPathsFiles(selectedItems) || ids?.deleteAccess) &&
                    <>
                      <i
                        title="Delete"
                        className="fa-solid fa-trash-alt CP text-danger"
                        onClick={() => softDeleteS3EditorFolder(selectedItems?.map(item => item.fullPath))}
                      />
                      <div className="vr"></div>
                    </>
                  }
                </>
              )}
            </>
          )}
          <div className="position-relative">
            <Form.Control
              type="search"
              onChange={(e) => setSearchData(e.target.value)}
              value={searchData}
              placeholder="Search..."
              style={{ width: 250, padding: "3px 10px" }}
            />
            <CiSearch
              className="CP position-absolute bg-white"
              title="Search"
              style={{ width: 15, top: 4, right: 7 }}
            />
          </div>
        </div>

        <div className="hstack gap-2">
          {(selectedItems?.length > 0 && selectedItems.every(item => !!item.url)) &&
            <button
              className="text-primary border-primary"
              style={{ background: "transparent", borderRadius: 3, fontSize: 12, padding: "3px 10px 4px", transition: "1s", border: "1px solid" }}
              onClick={() => downloadDocumentFile(selectedItems)}
            >
              Download File{selectedItems?.length > 1 ? "s" : ""}
            </button>
          }
          <button
            className={`${!breadcrumb ? "text-success border-success" : "text-danger border-danger"}`}
            style={{ background: "transparent", borderRadius: 3, fontSize: 12, padding: "3px 10px 4px", transition: "1s", border: "1px solid" }}
            onClick={() => setBreadcrumb(!breadcrumb)}
          >
            {!breadcrumb ? "View" : "Hide"} Breadcrumb
          </button>
          <button
            className={`${viewType === "grid" && "text-white"} updateProfile`}
            style={{ backgroundColor: viewType === "grid" && "#103c5e" }}
            onClick={() => { setViewType("grid") }}
          >
            Grid View
          </button>
          <button
            className={`${viewType === "list" && "text-white"} updateProfile`}
            style={{ backgroundColor: viewType === "list" && "#103c5e" }}
            onClick={() => setViewType("list")}
          >
            List View
          </button>
        </div>
      </div>
      <Collapse in={breadcrumb}>
        <div className="toolbar border-bottom">
          <Breadcrumb>
            <Breadcrumb.Item
              active={breadcrumbData?.length === 0}
              className="fw-bold"
              onClick={() => {
                handleAddNewTab(`File Management`,
                  "fa-solid fa-desktop",
                  `fileManagement`
                )
              }}
            >
              File Management
            </Breadcrumb.Item>
            {breadcrumbData?.length > 0 && breadcrumbData?.map((pathName, index) => (
              <Breadcrumb.Item
                key={index}
                className="fw-bold"
                active={index === breadcrumbData?.length - 1}
                onClick={() => {
                  if (index !== breadcrumbData?.length - 1) {
                    getPathOnClick(pathName)
                  }
                }}
              >
                {pathName}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      </Collapse>

      {/* Content Area */}
      <SplitPane
        split="vertical"
        minSize={fileURL ? "65%" : "100%"}
        className="position-relative"
        style={{ height: breadcrumb ? "calc(100vh - 214px)" : "calc(100vh - 180px)" }}
      >
        {loader ? (
          <PageLoader />
        ) : fileManager?.length === 0 ? (
          <NoDataFoundTable MSG={"File or Folder not found!"} />
        ) : (
          <>
            {/* GRID VIEW */}
            {viewType === "grid" && (
              <div ref={gridRef} className="d-flex flex-wrap">
                {fileManager?.map((item, index) => (
                  <div
                    key={item.name}
                    className={`text-center m-2 position-relative CP p-1 ${isSelected(item.fullPath) ? "selectedMenu br3" : ""
                      }`}
                    onClick={(e) => {
                      handleItemClick(e, item, index)
                    }}
                    onDoubleClick={(e) => {
                      if (!item.isFile) {
                        getS3EditorFolders(item.fullPath)
                        handleAddNewTab(`File Management`,
                          "fa-solid fa-desktop",
                          `fileManagement`,
                          item
                        )
                        e.stopPropagation()
                      } else {
                        if (isFile(item.fullPath) === "csv" || isFile(item.fullPath) === "csv" || isFile(item.fullPath) === "xlsx" || isFile(item.fullPath) === "xls") {
                          handleAddNewTab(`${item?.name}`,
                            "fa-solid fa-database",
                            `readS3DatasetManagement_${item?.fullPath}`,
                            item
                          )
                          e.stopPropagation()
                        } else {
                          setFileURL(item.url)
                          e.stopPropagation()
                        }
                      }
                    }}
                    title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nCreated DT: ${item.createdAt}\nUpdated DT: ${item.updatedAt}`}
                    style={{ width: 120, userSelect: "none" }}
                  >
                    <Form.Check
                      type="checkbox"
                      checked={isSelected(item.fullPath)}
                      onChange={() => handleCheckboxChange(item, index)}
                      onClick={(e) => e.stopPropagation()}
                      className="position-absolute top-0 start-0 m-1"
                    />
                    {!item.isFile ? (
                      item?.children?.length > 0 ?
                        <>
                          {item?.name === "Uncategories" ?
                            <IoFolder className="text-info" style={{ fontSize: 60 }} />
                            :
                            <BsFillFolderFill className="text-warning" style={{ fontSize: 60 }} />
                          }
                        </>
                        :
                        <>
                          {item?.name === "Uncategories" ?
                            <IoFolder className="text-info" style={{ fontSize: 60 }} />
                            :
                            <FaFolder className="text-warning" style={{ fontSize: 60 }} />
                          }
                        </>
                    ) : (
                      <>
                        {isFile(item?.fullPath) === "csv" ?
                          <GrDocumentCsv className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                          : isFile(item?.fullPath) === "xpt" ?
                            <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                            : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                              <BsImage className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                              : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                <GrDocumentExcel className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                : isFile(item?.fullPath) === "pdf" ?
                                  <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                  : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                    <GrDocumentWord className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                    : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                      <GrDocumentPpt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                      : (isFile(item?.fullPath) === "zip") ?
                                        <GoFileZip className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                        : isFile(item?.fullPath) === "txt" ?
                                          <GrDocumentTxt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                          : isFile(item?.fullPath) === "rtf" ?
                                            <GrDocumentRtf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                            :
                                            <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                        }
                      </>
                    )}
                    <div className="mt-1 small text-truncate fontSize12">{item.name}</div>
                  </div>
                ))}
              </div>
            )}

            {/* LIST VIEW */}
            {viewType === "list" && (
              <Table
                className="m-0 custom-table"
                ref={(el) => {
                  tableDRef.current = el;
                  tableRef.current = el;
                }}
                borderless
                hover
              >
                <thead className="position-sticky top-0 z-1 bg-white">
                  <tr>
                    <th onMouseDown={(e) => onMouseDown(e, 0)}>Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Created Date | Time
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Updated Date | Time
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {fileManager?.map((item, index) => (
                    <tr
                      key={item.name}
                      className={`${isSelected(item.fullPath) ? "selectedMenu" : ""
                        } CP`}
                      onClick={(e) => {
                        handleItemClick(e, item, index)
                      }}
                      onDoubleClick={(e) => {
                        if (!item.isFile) {
                          getS3EditorFolders(item.fullPath)
                          handleAddNewTab(`File Management`,
                            "fa-solid fa-desktop",
                            `fileManagement`,
                            item
                          )
                          e.stopPropagation()
                        } else {
                          if (isFile(item.fullPath) === "csv" || isFile(item.fullPath) === "csv" || isFile(item.fullPath) === "xlsx" || isFile(item.fullPath) === "xls") {
                            handleAddNewTab(`${item?.name}`,
                              "fa-solid fa-database",
                              `readS3DatasetManagement_${item?.fullPath}`,
                              item
                            )
                            e.stopPropagation()
                          } else {
                            setFileURL(item.url)
                            e.stopPropagation()
                          }
                        }
                      }}
                      title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nCreated DT: ${item.createdAt}\nUpdated DT: ${item.updatedAt}`}
                      style={{ userSelect: "none" }}
                    >
                      <td className="border-0">
                        <div className="hstack gap-2">
                          <Form.Check
                            type="checkbox"
                            checked={isSelected(item.fullPath)}
                            onChange={() =>
                              handleCheckboxChange(item, index)
                            }
                            onClick={(e) => e.stopPropagation()}
                          />
                          <div style={{ width: 15 }}>
                            {!item.isFile ? (
                              item?.children?.length > 0 ?
                                <>
                                  {item?.name === "Uncategories" ?
                                    <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                    :
                                    <BsFillFolderFill className="text-warning" style={{ fontSize: 15 }} />
                                  }
                                </>
                                :
                                <>
                                  {item?.name === "Uncategories" ?
                                    <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                    :
                                    <FaFolder className="text-warning" style={{ fontSize: 15 }} />
                                  }
                                </>
                            ) : (
                              <>
                                {isFile(item?.fullPath) === "csv" ?
                                  <GrDocumentCsv className="text-secondary" style={{ fontSize: 15 }} />
                                  : isFile(item?.fullPath) === "xpt" ?
                                    <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                    : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                                      <BsImage className="text-secondary" style={{ fontSize: 15 }} />
                                      : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                        <GrDocumentExcel className="text-secondary" style={{ fontSize: 15 }} />
                                        : isFile(item?.fullPath) === "pdf" ?
                                          <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 15 }} />
                                          : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                            <GrDocumentWord className="text-secondary" style={{ fontSize: 15 }} />
                                            : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                              <GrDocumentPpt className="text-secondary" style={{ fontSize: 15 }} />
                                              : (isFile(item?.fullPath) === "zip") ?
                                                <GoFileZip className="text-secondary" style={{ fontSize: 15 }} />
                                                : isFile(item?.fullPath) === "txt" ?
                                                  <GrDocumentTxt className="text-secondary" style={{ fontSize: 15 }} />
                                                  : isFile(item?.fullPath) === "rtf" ?
                                                    <GrDocumentRtf className="text-secondary" style={{ fontSize: 15 }} />
                                                    :
                                                    <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                }
                              </>
                            )}
                          </div>
                          <span className="text-truncate">{item.name}</span>
                        </div>
                      </td>
                      <td className="border-0">{item.createdAt}</td>
                      <td className="border-0">{item.updatedAt}</td>
                      <td className="border-0">{!item.isFile ? "Folder" : <span className="text-uppercase">{isFile(item?.fullPath)}</span>}</td>
                      <td className="border-0">{item.sizeMB}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
        {fileURL && (
          <FilePreview FileUrl={fileURL} ref={fileURLRef} HeightData={breadcrumb ? "calc(100vh - 214px)" : "calc(100vh - 180px)"} />
        )}
      </SplitPane>
      <AddNewFolder
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        setFileFolderUpdater={setFileFolderUpdater}
        Title="Add New Folder"
        folderData={selectedItems?.length === 1 ? selectedItems?.[0]?.fullPath : ids}
      />
      <UpdateFolder
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Update Selected Item`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={updateRef}
      />
      <CopyFolder
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Copy Selected Item`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={copyRef}
      />
      <MoveFolder
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Move Selected Item`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={moveRef}
      />
      <DuplicateFolder
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Duplicate Selected Item`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={duplicateRef}
      />
      <UploadMultiFilesFolders
        Show={!toggles.toggle5}
        Hide={toggles.setToggle5}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Upload Files / Folders`}
        sourceKey={selectedItems?.length === 1 ? selectedItems?.[0]?.fullPath : ids?.fullPath}
        ref={uploadRef}
      />
      <GenerateZipFile
        Show={!toggles.toggle6}
        Hide={toggles.setToggle6}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Generate Zip`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={generateZipRef}
      />
      <ExtractedZipFile
        Show={!toggles.toggle7}
        Hide={toggles.setToggle7}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Extract Zip`}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={extractZipRef}
      />
    </>
  );
};

export default FileManagement;
